<template>
  <DBox
    :id="'cm-invoice-reminder-contact-list-container'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('invoice')}`"
  >
    <NTable
      id="licencing-licence_accounts-sidewindow-invoices dbox1"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td
            @click="onInvoiceReminderContactClick(item)"
            :title="$t('click_to_see_contact_details')"
            style="cursor:pointer;font-weight:900"
            v-bind="tdcon('contact')"
          >
            <span
              ><b>{{ item["fullname"] }}</b></span
            >
          </td>
          <td v-bind="tdcon('invoice_project')">
            <span>{{ item["invoice_project_name"] }}</span>
          </td>

          <td v-bind="tdcon('invoice_count')">
            <span>{{ item["invoices"] }}</span>
          </td>
          <td v-bind="tdcon('level')">
            <span>{{ item["max_dunning_level"] }}</span>
          </td>
          <td v-bind="tdcon('open_amount')">
            <span v-if="item['amount_due_cc']" style="text-align:right"
              >{{ item["amount_due_cc"] + " "
              }}<template v-if="item['currency_iso']">{{
                item["currency_iso"]
              }}</template></span
            >
          </td>
          <td v-bind="tdcon('options')">
            <img
              v-if="item['email1']"
              src="static/icons/email/email-grey.svg"
              @click.stop="e => onSendMail(item)"
              class="dt-icon v5 s2 ut-center"
              alt
            />
          </td>
          <td v-bind="tdcon('options1')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteInvoiceReminderContact(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import InputField from "@plugins/text-field/input-field";
import DatePicker from "@plugins/text-field/date-picker";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { sendMailHref } from "../../../../utility";
import { InvoiceReminderService } from "../../services/invoice-reminder.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    NTable,
    InputField,
    DatePicker,
    DBox
  },
  props: {
    selectedInvoiceReminder: {
      required: true
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("contact", {}),
        createTableHeader("invoice_project", {}),
        createTableHeader("invoice_count", {
          text: this.$t("invoice_count"),
          ta: "right"
        }),
        createTableHeader("level", { ta: "right" }),
        createTableHeader("open_amount", { ta: "right" }),
        createTableHeader("options", { text: false, mw: 30 }),
        createTableHeader("options1", { text: false, mw: 30 })
      ];
    },
    list: function() {
      return this.selectedInvoiceReminder.invoice_reminder_contacts || [];
    },
    invoiceReminder: function() {
      return this.selectedInvoiceReminder.invoice_reminder || {};
    }
  },
  methods: {
    onInvoiceReminderContactClick: function(item) {
      const { invoice_reminder_contact_id } = item;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "contact_invoices",
          irc_id: invoice_reminder_contact_id
        }
      });
    },
    onSendMail: async function(item) {
      const resData = (await InvoiceReminderService.findInvoiceReminderContacts(
        { invoice_reminder_contact_id: item.invoice_reminder_contact_id }
      )).data;
      console.log("::::", resData.invoices, item);

      const body = `----------------------------------\nInvoice No:${
        resData.invoices[0].invoice_ref
      }	 Date: ${resData.invoices[0].invoice_date}	 Due: ${"2021-08-18"}\n${
        resData.invoices[0].subject
      }\nTotal: ${item.amount_due_cc} ${
        item.currency_iso
      }\n----------------------------------\nGrand Total: ${
        item.amount_due_sc
      } ${item.currency_iso}`;

      sendMailHref({
        mails: [item["email1"]],
        body: body,
        subject: `Invoice Reminder ${this.invoiceReminder.account_check_date}`
      });
    },

    onDeleteInvoiceReminderContact: async function(item) {
      const confirmationResult = await confirmDelete("contact", item.fullname);
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cm-invoice-reminder-contact-list-container {
  .dt-ntable {
    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4) {
        display: none !important;
      }
    }
  }
}
</style>
